import { getRoute } from '@/helpers/RouteHelper';
import { useLocation } from '@reach/router';

/**
 * @description returns insurance, takaful
 */
export function useRouteSection() {
  const location = useLocation();
  const { entity } = getRoute(location.pathname);
  return entity;
}

export function getHost() {
  return useLocation().host;
}
